<div class="profile-container">
  <h2>
    Hola, <strong>{{ getUser() }}</strong>
  </h2>
</div>
